import { Actions } from './roles.actions'
import { fromJS } from 'immutable'
import * as RolesTypes from './roles.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 10,
    },
    total: 0,
    filtered: 0,
  },
  permissions: {
    isLoading: false,
    data: [],
  },
  createRole: {
    isLoading: false,
    validationErrors: {},
    data: {
      name: '',
      title: '',
      permissions: [],
    },
  },
  updateRole: {
    isLoading: false,
    validationErrors: {},
    data: {
      name: '',
      title: '',
      permissions: [],
    },
  },
})

export function rolesReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case RolesTypes.UPDATE_ROLE_REQUEST: {
      return state.setIn(['updateRole', 'isLoading'], true)
    }

    case RolesTypes.UPDATE_ROLE_SUCCESS: {
      return state.setIn(['updateRole', 'isLoading'], false)
    }

    case RolesTypes.UPDATE_ROLE_FAILURE: {
      return state.setIn(['updateRole', 'isLoading'], false)
    }

    case RolesTypes.CREATE_ROLE_REQUEST: {
      return state.setIn(['createRole', 'isLoading'], true)
    }

    case RolesTypes.CREATE_ROLE_SUCCESS: {
      return state.setIn(['createRole', 'isLoading'], false)
    }

    case RolesTypes.CREATE_ROLE_FAILURE: {
      return state.setIn(['createRole', 'isLoading'], false)
    }

    case RolesTypes.DELETE_ROLE_REQUEST: {
      return state
    }

    case RolesTypes.DELETE_ROLE_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case RolesTypes.DELETE_ROLE_FAILURE: {
      return state
    }

    case RolesTypes.FETCH_ROLES_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case RolesTypes.FETCH_ROLES_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'filtered'], fromJS(action.filtered))
    }

    case RolesTypes.FETCH_ROLES_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case RolesTypes.FETCH_PERMISSIONS_REQUEST: {
      return state.setIn(['permissions', 'isLoading'], true)
    }

    case RolesTypes.FETCH_PERMISSIONS_SUCCESS: {
      return state
        .setIn(['permissions', 'isLoading'], false)
        .setIn(['permissions', 'data'], fromJS(action.payload))
    }

    case RolesTypes.FETCH_PERMISSIONS_FAILURE: {
      return state.setIn(['permissions', 'isLoading'], false)
    }

    case RolesTypes.FETCH_ROLE_REQUEST: {
      return state.setIn(['updateRole', 'isLoading'], true)
    }

    case RolesTypes.FETCH_ROLE_SUCCESS: {
      return state
        .setIn(['updateRole', 'isLoading'], false)
        .setIn(
          ['updateRole', 'data'],
          fromJS(action.payload).delete('streetType').delete('id'),
        )
    }

    case RolesTypes.FETCH_ROLE_FAILURE: {
      return state.setIn(['updateRole', 'isLoading'], false)
    }

    case RolesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case RolesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
